import styled from 'styled-components';

export const StyledGoogleSignIn = styled.div`
  .google-sign-in {
    margin-top: 40px;
    display: flex;
    justify-content: center;

    &__circle-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      /* Scale up the Google button to match Facebook/Twitter size */
      > div {
        transform: scale(1.25);
      }
    }
  }
`;
